const resumo_de_salas_versus_turmas = {
  path: "/relatorio-de-apoio-gerencial-resumo-de-salas-versus-turmas",
  redirect: "/relatorio-de-apoio-gerencial-resumo-de-salas-versus-turmas",
  meta: {
    breadCrumb:
      "Gerenciamento de Matrícula - Apoio Gerencial de Planejamento da Matrícula",
  },
  children: [
    {
      path: "/relatorio-de-apoio-gerencial-resumo-de-salas-versus-turmas",
      name: "relatorio_de_apoio_gerencial_resumo_de_salas_versus_turmas",
      meta: {
        allowedPermissions: ["utilizacao_salas_escola"],
      },
      component: () =>
        import(
          "@/views/RelatorioApoioGerencialResumoDeSalasVersusTurnos/RelatorioApoioGerencialResumoDeSalasVersusTurnos.vue"
        ),
    },
    {
      path: "/relatorio-de-apoio-gerencial-escolas-sem-turmas-criadas",
      name: "relatorio_de_apoio_gerencial_escolas_sem_turmas_criadas",
      meta: {
        allowedPermissions: ["estrutura_turma_escola_sem_turma"],
      },
      component: () =>
        import(
          "@/views/RelatorioApoioGerencialEscolasSemTurmasCriadas/RelatorioApoioGerencialEscolasSemTurmasCriadas.vue"
        ),
    },
  ],
};

export { resumo_de_salas_versus_turmas };
